import {
    type RejectAccountDeletionRequestResponseType,
    type RejectAccountDeletionRequestRequestType
} from "./type";
import {
    request
} from "../request";

const rejectAccountDeletionRequest = async (
    params: RejectAccountDeletionRequestRequestType
): Promise<RejectAccountDeletionRequestResponseType> => {
    return await request<RejectAccountDeletionRequestResponseType>(
        "/request/rejectAccountDeletionRequest",
        {
            body: JSON.stringify(params),
            method: "POST"
        }
    );
};
export default rejectAccountDeletionRequest;
